import { TASK_TITLES, type TaskDirection, type RVTask, type TaskAttributesTitle } from "@regal-voice/shared-types";

import { getTaskPreference } from "Services/TasksPreferences";

export const INBOUND_TASKS_TO_IGNORE: TaskAttributesTitle[] = [
    TASK_TITLES.SCHEDULED_CALLBACK,
    TASK_TITLES.ASAP_CALLBACK,
    // Outbound calls with inbound direction are power dial calls
    TASK_TITLES.OUTBOUND_CALL,
];

export const openTaskUrlIfNeeded = (task: RVTask) => {
    const title = task.attributes.title as TaskAttributesTitle | undefined;
    if (!title) {
        return;
    }

    const direction = task.attributes.direction as TaskDirection | undefined;
    if (direction === "inbound" && INBOUND_TASKS_TO_IGNORE.includes(title)) {
        return;
    }

    const { enabled } = getTaskPreference({
        name: "tasksAutoOpenUrl",
        taskTitle: title as TaskAttributesTitle,
    });

    if (!enabled) {
        return;
    }

    let { openUrl } = task.attributes;
    if (typeof openUrl !== "string") {
        return;
    }

    if (openUrl.match(/^www\./i)) {
        openUrl = `https://${openUrl}`;
    } else if (!openUrl.match(/^https?:\/\//i)) {
        return;
    }

    window.open(openUrl, "_blank", "noopener");
    window.focus();
};
